import { PageConfig, PageStyle } from '../../components/page-view/types';
import { LayoutType } from '../../constants';
import { hasStandaloneLayout } from '../../constants/pc';
import ebdcoms from '../ebdcoms';
import { LayoutInfo, StyleConfigAttrs } from './types';

/**
 * 默认卡片的左右，上下间距
 */
const dftMargin = [10, 10];

/**
 * 默认页面列数
 */
const dftCols = 12;

/**
 * 默认拖拽的步长
 */
const dftRowHeight = 1;

const dftCardStyle = {
  [LayoutType.GridLayout]: {
    rowSpace: 10,
    margin: dftMargin as [number, number],
    boxShadow: '',
  },
  [LayoutType.FlowLayout]: {
    margin: [0, 0] as [number, number],
  },
};
export const dftPageStyle = {
  [LayoutType.GridLayout]: {
    padding: {
      space: '10px 20px 10px 20px',
      selectedId: 'default',
    },
  },
  [LayoutType.FlowLayout]: {
    padding: {
      space: '0px 0px 0px 0px',
      selectedId: 'default',
    },
  },
};
const defConfigStyle = {
  layout: {
    column: dftCols,
    rowHeight: dftRowHeight,
  },
};

const getPageStyle = (layoutType: LayoutType, style?: PageStyle) => {
  const pageStyle = style || { ...dftPageStyle[layoutType] };
  const { padding } = pageStyle;

  if (padding?.selectedId === 'default' || !padding?.space) {
    pageStyle.padding = {
      ...dftPageStyle[layoutType].padding,
    };
  }

  return pageStyle;
};

export function formatConfig(config: PageConfig, layoutType: LayoutType): PageConfig {
  const { cardStyle, style } = config;

  return {
    ...config,
    style: {
      ...defConfigStyle,
      ...(config.style as any),
      page: getPageStyle(layoutType, style?.page),
    },
    cardStyle: {
      ...dftCardStyle,
      ...cardStyle,
    },
  };
}

const parseNum = (num: string) => {
  const number = parseInt(num, 10);

  return isNaN(number) ? 0 : number;
};

/**
 * 计算margin上下的距离之后
 * @param margin
 */
const getMarginTB = (margin: any) => {
  const { margin: _margin, marginTop, marginBottom } = margin;

  if (_margin !== undefined) {
    const space = parseNum(_margin);

    return [space, space];
  }

  // 存在只设置了marginTop或者marginBottom的情况
  if (marginTop !== undefined || marginBottom !== undefined) {
    return [parseNum(marginTop), parseNum(marginBottom)];
  }

  return [0, 0];
};

function getCssProps(data: StyleConfigAttrs, layoutInfo: LayoutInfo) {
  const {
    width, margin: marginCfg, padding: paddingCfg, background, ...restStyleCfg
  } = data;
  const { layoutType, scrollType, isFlow } = layoutInfo;
  let margin: any = { margin: 'auto' };
  let padding = isFlow ? {} : { padding: dftPageStyle[LayoutType.GridLayout].padding.space };
  let { height } = data;
  let minHeight = '100%';

  if (marginCfg?.space) {
    margin = ebdcoms.excu('parseMPSpace')(marginCfg.space, 'margin');

    // 当存在margin且没有设置height时
    // 计算实际的高度(减去上下margin)，不然会有滚动条
    if (!height) {
      const [marginTop, marginBottom] = getMarginTB(margin);

      height = `calc(100% - ${marginTop + marginBottom}px)`;
    }
  }

  if (paddingCfg?.space) {
    padding = ebdcoms.excu('parseMPSpace')(paddingCfg.space, 'padding');
  }

  if (hasStandaloneLayout.includes(layoutType!) && scrollType !== 'standalone') {
    minHeight = height || '100%';
    height = 'auto';
  } else if (height) {
    minHeight = 'auto';
  }

  return {
    ...restStyleCfg,
    ...padding,
    ...margin,
    ...background,
    height,
    minHeight,
    width: width || (marginCfg?.space && 'auto'),
  };
}

export function initStyledClass(data: StyleConfigAttrs, layoutInfo: LayoutInfo) {
  const time = Date.now();
  const cssProps = getCssProps(data, layoutInfo);
  const cssFragment = ebdcoms.excu('parseAttrToCss')(cssProps);

  ebdcoms.excu('createCssText')(
    '',
    cssFragment,
    false,
    undefined,
    `#${layoutInfo.scopeId}.ebpage-pc`,
    time,
    'ebpage-pc',
    'ebd_page',
  );
}

export default {};
